import { ExternalChartComponentProps } from '../../data-viz-containers/common/types';
import {
  OverTimeSegmentedViz,
  OverTimeSegmentedVizProps,
} from '../../data-viz-containers/overtime-segmented-query/OverTimeSegmentedViz';
import { OverTimeSegmentedVizViews } from '../../data-viz-containers/overtime-segmented-query/types';
import {
  StoryboardComponentIds,
  StoryboardComponentSettings,
} from '../common/types';
import { OverTimeSegmentedStoryboardComponentConfig } from './types';

const componentConfigToVizContainerProps = (
  componentConfig: OverTimeSegmentedStoryboardComponentConfig,
  externalProps: ExternalChartComponentProps,
  persistenceKey: string
) => {
  return {
    dataConfig: componentConfig.dataConfig,
    selectedView: componentConfig.selectedView,
    externalProps: externalProps,
    persistenceKey: persistenceKey,
  };
};

export const overTimeSegmentedStoryboardComponentSettings: StoryboardComponentSettings<
  OverTimeSegmentedStoryboardComponentConfig,
  OverTimeSegmentedVizProps
> = {
  componentId: StoryboardComponentIds.OVERTIME_SEGMENTED,
  componentConfigToVizContainerProps: componentConfigToVizContainerProps,
  VizContainerComponent: OverTimeSegmentedViz,
  validateConfig: (componentConfig) => {
    const { selectedView, dataConfig } = componentConfig;
    const { segmentBy, benchmarkConfig } = dataConfig;
    if (
      segmentBy &&
      benchmarkConfig &&
      selectedView === OverTimeSegmentedVizViews.BAR_CHART
    ) {
      return {
        isValid: false,
        error: new Error(
          'Bar chart view for overtime segmented queries does not support benchmark'
        ),
      };
    }
    return {
      isValid: true,
      error: null,
    };
  },
};
